if (!customElements.get('product-gallery')) {
  class ProductGallery extends HTMLElement {
    constructor() {
      super()
      this.swiper = null
      this.swiperThumbs = null
    }

    connectedCallback() {
      this.productInfo = this.closest('product-info')
      this.swiperElement = this.querySelector('.js-swiper')
      this.swiperThumbsElement = this.querySelector('.js-swiper-thumbs')
      this.productMediaSize = this.dataset.productMediaSize
      this.selectedVariantImagePosition = Number(
        this.productInfo.dataset.selectedVariantImagePosition,
      )

      this.initThumbs()
      setTimeout(() => {
        this.init()
      }, 500)
      this.zoomGalleryDesktop()
    }

    init() {
      const swiperNextButton = this.querySelector('.js-swiper-button-next')
      const swiperPrevButton = this.querySelector('.js-swiper-button-prev')
      const swiperPagination = this.querySelector('.swiper-pagination')

      if (!this.swiperElement) return

      const swatchChanged = this.productInfo.swatchChanged || false

      const useFirstImageOnLoad = this.dataset.useFirstImageOnLoad === 'true'

      const initialSlide =
        this.selectedVariantImagePosition > 1
          ? this.selectedVariantImagePosition
          : useFirstImageOnLoad
            ? 0
            : this.productInfo.dataset.productPackSize === 'Single' || swatchChanged
              ? 0
              : 1

      this.swiper = new Swiper(this.swiperElement, {
        initialSlide: initialSlide,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        // lazy: true,
        navigation: {
          nextEl: swiperNextButton,
          prevEl: swiperPrevButton,
        },
        pagination: {
          el: swiperPagination,
          type: 'progressbar',
        },
        thumbs: {
          swiper: !this.swiperThumbsElement ? null : this.swiperThumbs,
        },
        breakpoints: {
          500: {
            slidesPerView: 1,
            spaceBetween: 2,
          },
        },
        on: {
          afterInit: () => {
            setTimeout(() => {
              swiperPrevButton.classList.remove('loading')
              swiperNextButton.classList.remove('loading')
              this.swiperElement.classList.remove('loading')
            }, 100)
          },
        },
      })
    }

    initThumbs() {
      if (!this.swiperThumbsElement) return

      this.swiperThumbs = new Swiper(this.swiperThumbsElement, {
        spaceBetween: 12,
        slidesPerView: 5.5,
        direction: 'vertical',
        mousewheel: true,
        // lazy: true,
      })
    }

    zoomGalleryDesktop() {
      const ZoomConfig = {
        initialZoom: 3,
        minZoom: 1.25,
        maxZoom: 4,
        zoomSpeed: 0.01,
      }

      this.swiperElement
        .querySelectorAll('.liquid-pdp__gallery-image')
        .forEach((imageContainer) => {
          const img = imageContainer.querySelector('img')
          img.draggable = false

          // Add required CSS classes and styles
          imageContainer.classList.add('zoomable-container')
          img.classList.add('zoomable-img')

          // Set initial CSS variables
          imageContainer.style.setProperty('--zoom', ZoomConfig.initialZoom)

          let zoomed = false
          let currentZoom = ZoomConfig.initialZoom

          // Mouse enter handler
          imageContainer.addEventListener('mouseenter', () => {
            zoomed = true
            imageContainer.classList.add('zoomed')
          })

          // Mouse move handler
          imageContainer.addEventListener('mousemove', (e) => {
            if (!zoomed) return

            const rect = imageContainer.getBoundingClientRect()
            const percentageX = `${((e.clientX - rect.left) * 100) / rect.width}%`
            const percentageY = `${((e.clientY - rect.top) * 100) / rect.height}%`

            imageContainer.style.setProperty('--zoom-pos-x', percentageX)
            imageContainer.style.setProperty('--zoom-pos-y', percentageY)
          })

          // Mouse leave handler
          imageContainer.addEventListener('mouseleave', () => {
            zoomed = false
            imageContainer.classList.remove('zoomed')
            imageContainer.style.setProperty('--zoom', ZoomConfig.initialZoom)
            currentZoom = ZoomConfig.initialZoom
          })

          // Mouse wheel handler for zoom control
          // imageContainer.addEventListener('wheel', (e) => {
          //   if (!zoomed) return
          //   e.preventDefault()

          //   const newZoom = currentZoom + e.deltaY * (ZoomConfig.zoomSpeed * -1)
          //   currentZoom = Math.max(Math.min(newZoom, ZoomConfig.maxZoom), ZoomConfig.minZoom)
          //   imageContainer.style.setProperty('--zoom', currentZoom)
          // })
        })
    }

    // Updates gallery from html content on PDP
    updateGallery(newContent) {
      // console.log('updateGallery', newContent)
      if (!this.swiper) return

      if (this.swiperThumbs) {
        const currentSlidesPerView = this.swiperThumbs.params.slidesPerView

        const swiperWrapper = this.swiperThumbsElement.querySelector('.swiper-wrapper')
        if (swiperWrapper) {
          swiperWrapper.innerHTML = newContent.querySelector(
            '.js-swiper-thumbs .swiper-wrapper',
          ).innerHTML

          swiperWrapper.querySelectorAll('video').forEach((video) => {
            video.play().catch((error) => {
              console.warn('Video autoplay failed:', error)
            })
          })
        }

        this.swiperThumbs.destroy(true, true)
        this.initThumbs()
        this.swiperThumbs.params.slidesPerView = currentSlidesPerView
        this.swiperThumbs.update()
      }

      // const currentIndex = this.swiper.activeIndex
      const currentSlidesPerView = this.swiper.params.slidesPerView

      // Update content
      const swiperWrapper = this.swiperElement.querySelector('.swiper-wrapper')
      if (swiperWrapper) {
        swiperWrapper.innerHTML = newContent.querySelector('.js-swiper .swiper-wrapper').innerHTML

        // Play any videos in the new slides
        swiperWrapper.querySelectorAll('video').forEach((video) => {
          video.play().catch((error) => {
            console.warn('Video autoplay failed:', error)
          })
        })
      }

      // Destroy and reinitialize with same configuration
      this.swiper.destroy(true, true)
      this.init()

      this.swiper.params.slidesPerView = currentSlidesPerView
      this.swiper.update()
      this.swiper.slideTo(0, 0)

      this.zoomGalleryDesktop()
    }

    // Updates gallery from json data from PDP
    updateGalleryMedia(mediaArray, carouselVideo, videoData) {
      // console.log('updateGalleryMedia', mediaArray, carouselVideo)
      if (!this.swiper) return

      if (this.swiperThumbs) {
        const currentSlidesPerView = this.swiperThumbs.params.slidesPerView

        const thumbsSwiperWrapper = this.swiperThumbsElement.querySelector('.swiper-wrapper')
        if (thumbsSwiperWrapper) {
          const currentCarouselVideo = this.swiperThumbsElement.querySelector('.js-carousel-video')

          let slidesHtml = mediaArray.map((media) => {
            if (media.media_type === 'video') {
              return `
                <li class="swiper-slide">
                  <div class="liquid-pdp__gallery-video">
                    <video autoplay loop muted playsinline src="${media.src}"></video>
                  </div>
                </li>
              `
            } else {
              return `
              <li class="swiper-slide">
                <div class="liquid-pdp__gallery-image">
                  <img
                    src="${media.src}&width=100"
                    alt="${media.alt || ''}"
                    loading="eager"
                    width="100"
                    height="100"
                  >
                </div>
              </li>
            `
            }
          })
          // Create a temporary container
          const tempContainer = document.createElement('div')
          tempContainer.innerHTML = slidesHtml.join('')

          // Get carousel videos from jsonData
          if (videoData && currentCarouselVideo) {
            const video_position = Number(videoData.video_position)
            // If we have a current carousel video and a valid position, keep it in place
            if (video_position >= 0) {
              // Insert the actual DOM element at the right position
              const slides = Array.from(tempContainer.children)
              slides.splice(video_position, 0, currentCarouselVideo)
              // Clear and append all slides
              thumbsSwiperWrapper.innerHTML = ''
              slides.forEach((slide) => thumbsSwiperWrapper.appendChild(slide))
            } else {
              thumbsSwiperWrapper.innerHTML = slidesHtml.join('')
            }

            const normalizeUrl = (url) => url.replace(/^\/\//, 'https://')

            const videoElement = currentCarouselVideo.querySelector('video')
            const currentUrl = normalizeUrl(videoElement.src)
            const familyVideoUrl = videoData?.family_carousel_video?.sources[0]?.url

            if (carouselVideo) {
              const newUrl = normalizeUrl(carouselVideo?.sources[0]?.url)
              if (newUrl && currentUrl !== newUrl) {
                videoElement.src = carouselVideo?.sources[0]?.url
                videoElement.load()
              }
            } else if (familyVideoUrl) {
              const newUrl = normalizeUrl(familyVideoUrl)
              if (newUrl && currentUrl !== newUrl) {
                videoElement.src = familyVideoUrl
                videoElement.load()
              }
            } else {
              // if new product has no video, remove the old video
              const oldVideo = thumbsSwiperWrapper.querySelector('.js-carousel-video')
              if (oldVideo) oldVideo.remove()
            }
          } else if (videoData && !currentCarouselVideo) {
            // Handle case where videoData exists but no current carousel video
            const video_position = Number(videoData.video_position)

            // Determine which video to use
            let videoUrl = null
            if (carouselVideo?.sources?.[0]?.url) {
              videoUrl = carouselVideo.sources[0].url
            } else if (videoData?.family_carousel_video?.sources?.[0]?.url) {
              videoUrl = videoData.family_carousel_video.sources[0].url
            }

            if (videoUrl && video_position >= 0) {
              // Create new carousel video slide
              const carouselVideoSlide = document.createElement('li')
              carouselVideoSlide.className = 'swiper-slide js-carousel-video'
              carouselVideoSlide.innerHTML = `
            <div class="liquid-pdp__gallery-video">
              <video autoplay loop muted playsinline src="${videoUrl}"></video>
            </div>
          `

              // Insert at the specified position
              const slides = Array.from(tempContainer.children)
              slides.splice(video_position, 0, carouselVideoSlide)

              // Clear and append all slides
              thumbsSwiperWrapper.innerHTML = ''
              slides.forEach((slide) => thumbsSwiperWrapper.appendChild(slide))
            } else {
              thumbsSwiperWrapper.innerHTML = slidesHtml.join('')
            }
          } else {
            thumbsSwiperWrapper.innerHTML = slidesHtml.join('')
          }

          // Play any NEW videos in the slides (skip the carousel video)
          thumbsSwiperWrapper
            .querySelectorAll('video:not(.js-carousel-video video)')
            .forEach((video) => {
              // video.style.opacity = 1
              if (!video.playing) {
                video.play().catch((error) => {
                  console.warn('Video autoplay failed:', error)
                })
              }
            })
        }
        this.swiperThumbs.destroy(true, true)
        this.initThumbs()
        this.swiperThumbs.params.slidesPerView = currentSlidesPerView
        this.swiperThumbs.update()
      }

      const currentSlidesPerView = this.swiper.params.slidesPerView

      // Disable loop temporarily
      this.swiper.params.loop = false
      this.swiper.update()
      this.swiper.slideTo(0, 0)

      let hasVideoAtPosition0 = false

      // Update content
      const swiperWrapper = this.swiperElement.querySelector('.swiper-wrapper')
      if (swiperWrapper) {
        // Get current carousel video if it exists
        const currentCarouselVideo = this.swiperElement.querySelector('.js-carousel-video')

        // Convert media array to slides HTML
        let slidesHtml = mediaArray.map((media) => {
          if (media.media_type === 'video') {
            return `
              <li class="swiper-slide">
                <div class="liquid-pdp__gallery-video">
                  <video autoplay loop muted playsinline src="${media.src}"></video>
                </div>
              </li>
            `
          } else {
            return `
              <li class="swiper-slide">
                <div class="liquid-pdp__gallery-image">
                  <img
                    src="${media.src}&width=1420"
                    srcset="${media.src}&width=275 275w, ${media.src}&width=550 550w, ${media.src}&width=710 710w, ${media.src}&width=1420 1420w"
                    alt="${media.alt || ''}"
                    loading="eager"
                    width="1420"
                    height="1420"
                  >
                </div>
              </li>
            `
          }
        })

        // Create a temporary container
        const tempContainer = document.createElement('div')
        tempContainer.innerHTML = slidesHtml.join('')

        // Get carousel videos from jsonData
        if (videoData && currentCarouselVideo) {
          const video_position = Number(videoData.video_position)
          // If we have a current carousel video and a valid position, keep it in place
          if (video_position >= 0) {
            if (video_position === 0) hasVideoAtPosition0 = true
            // Insert the actual DOM element at the right position
            const slides = Array.from(tempContainer.children)
            slides.splice(video_position, 0, currentCarouselVideo)
            // Clear and append all slides
            swiperWrapper.innerHTML = ''
            slides.forEach((slide) => swiperWrapper.appendChild(slide))
          } else {
            swiperWrapper.innerHTML = slidesHtml.join('')
          }

          const normalizeUrl = (url) => url.replace(/^\/\//, 'https://')

          const videoElement = currentCarouselVideo.querySelector('video')
          const currentUrl = normalizeUrl(videoElement.src)
          const familyVideoUrl = videoData?.family_carousel_video?.sources[0]?.url

          if (carouselVideo) {
            const newUrl = normalizeUrl(carouselVideo?.sources[0]?.url)
            if (newUrl && currentUrl !== newUrl) {
              videoElement.src = carouselVideo?.sources[0]?.url
              videoElement.load()
            }
          } else if (familyVideoUrl) {
            const newUrl = normalizeUrl(familyVideoUrl)
            if (newUrl && currentUrl !== newUrl) {
              videoElement.src = familyVideoUrl
              videoElement.load()
            }
          } else {
            // if new product has no video, remove the old video
            const oldVideo = swiperWrapper.querySelector('.js-carousel-video')
            if (oldVideo) oldVideo.remove()
            hasVideoAtPosition0 = false
          }
        } else if (videoData && !currentCarouselVideo) {
          // Handle case where videoData exists but no current carousel video
          const video_position = Number(videoData.video_position)

          // Determine which video to use
          let videoUrl = null
          if (carouselVideo?.sources?.[0]?.url) {
            videoUrl = carouselVideo.sources[0].url
          } else if (videoData?.family_carousel_video?.sources?.[0]?.url) {
            videoUrl = videoData.family_carousel_video.sources[0].url
          }

          if (videoUrl && video_position >= 0) {
            if (video_position === 0) hasVideoAtPosition0 = true
            // Create new carousel video slide
            const carouselVideoSlide = document.createElement('li')
            carouselVideoSlide.className = 'swiper-slide js-carousel-video'
            // carouselVideoSlide.style.opacity = 0
            carouselVideoSlide.innerHTML = `
              <div class="liquid-pdp__gallery-video">
                <video autoplay loop muted playsinline src="${videoUrl}" ></video>
              </div>
            `

            // Insert at the specified position
            const slides = Array.from(tempContainer.children)
            slides.splice(video_position, 0, carouselVideoSlide)

            // Clear and append all slides
            swiperWrapper.innerHTML = ''
            slides.forEach((slide) => swiperWrapper.appendChild(slide))
          } else {
            swiperWrapper.innerHTML = slidesHtml.join('')
          }
        } else {
          swiperWrapper.innerHTML = slidesHtml.join('')
        }

        // Play any NEW videos in the slides (skip the carousel video)
        swiperWrapper.querySelectorAll('video:not(.js-carousel-video video)').forEach((video) => {
          if (!video.playing) {
            video.play().catch((error) => {
              console.warn('Video autoplay failed:', error)
            })
          }
        })
      }

      // Destroy and reinitialize with same configuration
      this.swiper.destroy(true, true)
      this.init()
      this.swiper.params.slidesPerView = currentSlidesPerView

      // Re-enable loop and update
      this.swiper.params.loop = true
      this.swiper.update()
      this.swiper.slideTo(hasVideoAtPosition0 ? 1 : 0, 0)

      this.zoomGalleryDesktop()
    }

    goToPosition(position) {
      if (!this.swiper) return
      if (position === 1) position = 0 // Fix issue with wrong position since video is inserted outside media
      this.swiper.slideTo(position, 0)
    }
  }
  customElements.define('product-gallery', ProductGallery)
}
